var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: {
        "content-class": "auth-dialog-container",
        fullscreen: _vm.mobileBigAndBelow,
        persistent: ""
      },
      model: {
        value: _vm.vModelCondition,
        callback: function($$v) {
          _vm.vModelCondition = $$v
        },
        expression: "vModelCondition"
      }
    },
    [
      _vm.vModelCondition &&
      !_vm.iFrameLoaded &&
      _vm.showSpinnerWithDelay &&
      !_vm.loginDialogState
        ? _c("circle-loader")
        : _vm._e(),
      _vm._v(" "),
      _c("iframe", {
        ref: "authServerIframe",
        staticClass: "hiddenUntilIframeLoad",
        staticStyle: { border: "0", "z-index": "401" },
        style: { width: _vm.calculatedWidth, height: _vm.calculatedHeight },
        attrs: {
          "data-class": "auth-server-iframe",
          id: "iframe",
          scrolling: _vm.enableIframeScroll,
          allowfullscreen: "",
          frameborder: "0",
          src: this.authUrl
        },
        on: { load: _vm.iframeLoaded }
      }),
      _vm._v(" "),
      _c(
        "v-tooltip",
        {
          attrs: { location: "bottom", "content-class": "auth-tooltip" },
          model: {
            value: _vm.tooltip,
            callback: function($$v) {
              _vm.tooltip = $$v
            },
            expression: "tooltip"
          }
        },
        [_c("span", [_vm._v(_vm._s(_vm.tooltipText))])]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-798851f4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-798851f4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/AuthDialog.vue
// module id = null
// module chunks = 